import { createAction } from 'redux-actions';

export const sanitize = createAction('SANITIZE');
export const setRoot = createAction('SET_ROOT');
export const hardReset = createAction('HARD_RESET');
export const persistDataLoadComplete = createAction('PERSIST_DATA_LOAD_COMPLETE');

